// "use client";
// import React from "react";
// import { useQuery } from "@tanstack/react-query";
// import Client from "../../../utils/client";
// // import Client from "../../utils/client"; // adjust the path to your custom axios client

// function ProfileInfo() {
//     const { data: user, isLoading, isError, error } = useQuery({
//         queryKey: ["me"],
//         queryFn: async () => {
//             const response = await Client.get("/users/profile").then(res => res.data);
//             return response;
//         },
//     });

//     if (isLoading) return <div>جاري تحميل بياناتك...</div>;
//     if (isError) return <div>حدث خطأ أثناء تحميل البيانات: {error.message}</div>;

//     const userTypeLabels = {
//         farmer_cooperative: "جمعية زراعية",
//         consumer_cooperative: "جمعية استهلاكية",
//         supplier: "مورد",
//         service_provider: "شركة",
//         buyer: "مشتري",
//         farmer: "مزارع",
//         cooperative: "تعاونية",
//         marketer: "مسوق",
//     };

//     return (
//         <div dir="" className="text-start space-y-4">
//             <h2 className="text-2xl font-bold ">👋 مرحبًا، {user.name || "مستخدم"}</h2>

//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-sm text-start">
//                 <InfoItem label="رقم الهاتف" value={user.phonenumber} />
//                 <InfoItem
//                     label="نوع المستخدم"
//                     value={userTypeLabels[user.type] || "غير معروف"}
//                 />
//                 <InfoItem label="الولاية" value={user._state?.name} />
//                 <InfoItem label="الجنس" value={user.gender === "male" ? "ذكر" : user.gender === "female" ? "أنثى" : "-"} />
//                 <InfoItem label="عدد الأعضاء" value={user.NoOfMembers || "-"} />
//                 <InfoItem label="تم التحقق؟" value={user.isVerified ? "نعم" : "لا"} />
//             </div>

//             <div>
//                 <h3 className="font-semibold text-md mt-4 mb-1">الخدمات:</h3>
//                 <ul className="flex flex-wrap gap-2 text-sm">
//                     {user.services?.length > 0 ? user.services.map(s => (
//                         <li key={s.id} className="bg-secondary  rounded-full px-3 py-1">{s.name}</li>
//                     )) : <span>لا توجد خدمات</span>}
//                 </ul>
//             </div>

//             <div>
//                 <h3 className="font-semibold text-md mt-4 mb-1">المحاصيل:</h3>
//                 <ul className="flex flex-wrap gap-2 text-sm">
//                     {user.subCategories?.length > 0 ? user.subCategories.map(s => (
//                         <li key={s.id} className="bg-primary text-white rounded-full px-3 py-1">{s.name}</li>
//                     )) : <span>لا توجد محاصيل</span>}
//                 </ul>
//             </div>
//         </div>
//     );
// }

// function InfoItem({ label, value }) {
//     return (
//         <div className="flex flex-col items-start border-b pb-2">
//             <span className="">{label}</span>
//             <span className="font-medium text-black">{value || "-"}</span>
//         </div>
//     );
// }

// export default ProfileInfo;
"use client";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import Client from "../../../utils/client";

function ProfileInfo() {
    const { t, i18n } = useTranslation();
    
    const { data: user, isLoading, isError, error } = useQuery({
        queryKey: ["me"],
        queryFn: async () => {
            const response = await Client.get("/users/profile").then(res => res.data);
            return response;
        },
    });

    const userTypeLabels = {
        farmer_cooperative: t("profile.userTypes.farmerCooperative"),
        consumer_cooperative: t("profile.userTypes.consumerCooperative"),
        supplier: t("profile.userTypes.supplier"),
        service_provider: t("profile.userTypes.serviceProvider"),
        buyer: t("profile.userTypes.buyer"),
        farmer: t("profile.userTypes.farmer"),
        cooperative: t("profile.userTypes.cooperative"),
        marketer: t("profile.userTypes.marketer"),
    };

    const genderLabels = {
        male: t("profile.gender.male"),
        female: t("profile.gender.female"),
    };

    if (isLoading) return <div>{t("profile.loading")}</div>;
    if (isError) return <div>{t("profile.error")} {error.message}</div>;

    return (
        <div dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} className="space-y-4">
            <h2 className="text-2xl font-bold">
                {t("profile.welcome")} {user.name || t("profile.user")}
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-sm ">
                <InfoItem label={t("profile.phoneNumber")} value={user.phonenumber} />
                <InfoItem
                    label={t("profile.userType")}
                    value={userTypeLabels[user.type] || t("profile.unknown")}
                />
                <InfoItem label={t("profile.state")} value={user._state?.name} />
                <InfoItem 
                    label={t("profile.gender")} 
                    value={user.gender ? (genderLabels[user.gender] || "-") : "-"} 
                />
                <InfoItem label={t("profile.membersCount")} value={user.NoOfMembers || "-"} />
                <InfoItem 
                    label={t("profile.verified")} 
                    value={user.isVerified ? t("profile.yes") : t("profile.no")} 
                />
            </div>

            <div>
                <h3 className="font-semibold text-md mt-4 mb-1">{t("profile.services")}:</h3>
                <ul className="flex flex-wrap gap-2 text-sm">
                    {user.services?.length > 0 ? user.services.map(s => (
                        <li key={s.id} className="bg-secondary rounded-full px-3 py-1">{s.name}</li>
                    )) : <span>{t("profile.noServices")}</span>}
                </ul>
            </div>

            <div>
                <h3 className="font-semibold text-md mt-4 mb-1">{t("profile.crops")}:</h3>
                <ul className="flex flex-wrap gap-2 text-sm">
                    {user.subCategories?.length > 0 ? user.subCategories.map(s => (
                        <li key={s.id} className="bg-primary text-white rounded-full px-3 py-1">{s.name}</li>
                    )) : <span>{t("profile.noCrops")}</span>}
                </ul>
            </div>
        </div>
    );
}

function InfoItem({ label, value }) {
    const { i18n } = useTranslation();
    
    return (
        <div className="flex flex-col items-start border-b pb-2">
            <span className="">{label}</span>
            <span className="font-medium text-black">{value || "-"}</span>
        </div>
    );
}

export default ProfileInfo;